export default __webpack_public_path__ + "static/media/painscale_3.c410c1a8.png";